;
define("product_views_option_email.tpl", function(){});

